import { render } from "./ActionPlan.vue?vue&type=template&id=5e51b006"
import script from "./ActionPlan.vue?vue&type=script&lang=js"
export * from "./ActionPlan.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__